import React from 'react';
import { Typography, Button } from '../../components';
import {
    Container,
    Hero,
    HeroContent,
    HeroText,
    Section,
    SectionInner,
    IntroText,
    BarrierGrid,
    BarrierCard,
    BarrierNumber,
    BarrierTitle,
    ImageSection,
    ImagePlaceholder,
    FundSection,
    Highlight,
    NoliaSection,
    NoliaGrid,
    NoliaCard,
    RouteSection,
    Route,
    RouteItem,
    RouteNumber,
    RouteContent,
    CollaborationSection,
    CollaborationGrid,
    CollaborationCard,
    LearningSection,
    LearningList,
    StartSection,
    StartFlow,
    StartItem,
    FAQSection,
    FAQItem,
    ClosingSection,
    ClosingContent,
    CTAGroup,
    ParentSection,
} from './styled';

export default function Toegankelijkheidsfonds() {

    return (
        <Container>

            {/* HERO */}

            <Hero>
                <HeroContent>
                    <HeroText>

                        <Typography type='caps'>
                            NOLIA Toegankelijkheidsfonds
                        </Typography>

                        <Typography type='h1'>
                            Preventieve babyvoedingszorg toegankelijk voor iedere ouder<br />
                        </Typography>

                        <Typography type='h2'>
                            Een beschikbare plek is pas toegankelijk als een ouder er ook terechtkomt.<br /><br />
                        </Typography>

                        <Typography>
                            Goede voorbereiding op het voeden van je baby zou niet
                            afhankelijk moeten zijn van je financiële situatie,
                            waar je woont of hoe gemakkelijk je de juiste
                            ondersteuning weet te vinden.
                        </Typography>

                        <Typography>
                            Toch is preventieve babyvoedingszorg niet voor iedere
                            ouder vanzelfsprekend toegankelijk.
                        </Typography>

                        <Typography>
                            Met het <strong>NOLIA Toegankelijkheidsfonds</strong>
                            willen we daar verandering in brengen. We maken
                            deelname mogelijk voor ouders voor wie dit anders
                            minder vanzelfsprekend is én werken samen met lokale
                            partners aan iets wat minstens zo belangrijk is:
                            zorgen dat deze ouders het aanbod ook daadwerkelijk
                            weten te vinden en bereiken.
                        </Typography>

                        <Typography>
                            <strong>
                                Want een beschikbare plek is pas toegankelijk als
                                een ouder er ook terechtkomt.
                            </strong>
                        </Typography>

                    </HeroText>
                </HeroContent>
            </Hero>


            {/* TOEGANKELIJKHEID */}

            <Section>
                <SectionInner>

                    <Typography type='h2'>
                        Toegankelijkheid gaat over meer dan geld
                    </Typography>

                    <IntroText>
                        <Typography>
                            <br />Een bijeenkomst gratis aanbieden klinkt misschien als
                            dé oplossing. Maar wat als een ouder niet weet dat het
                            aanbod bestaat? Als een zorgprofessional niet weet naar
                            wie verwezen kan worden? Als de bijeenkomst te ver weg
                            is? Of als iemand zich niet herkent in het aanbod en
                            daardoor niet deelneemt?
                        </Typography>

                        <Typography>
                            Daarom kijken we binnen NOLIA breder naar
                            toegankelijkheid. We onderscheiden zes drempels:
                        </Typography>
                    </IntroText>

                    <BarrierGrid>

                        <BarrierCard>
                            <BarrierNumber>01</BarrierNumber>
                            <BarrierTitle>FINANCIEEL</BarrierTitle>
                            <Typography>
                                Kunnen ouders deelnemen zonder dat kosten een
                                belemmering vormen?
                            </Typography>
                        </BarrierCard>

                        <BarrierCard>
                            <BarrierNumber>02</BarrierNumber>
                            <BarrierTitle>VINDBAAR</BarrierTitle>
                            <Typography>
                                Weten ouders dat het aanbod bestaat en waar ze
                                het kunnen vinden?
                            </Typography>
                        </BarrierCard>

                        <BarrierCard>
                            <BarrierNumber>03</BarrierNumber>
                            <BarrierTitle>DICHTBIJ</BarrierTitle>
                            <Typography>
                                Is er passend aanbod in de buurt en is deelname
                                praktisch haalbaar?
                            </Typography>
                        </BarrierCard>

                        <BarrierCard>
                            <BarrierNumber>04</BarrierNumber>
                            <BarrierTitle>VERTROUWEN</BarrierTitle>
                            <Typography>
                                Voelt het aanbod veilig, herkenbaar en passend
                                genoeg om de stap naar deelname te zetten?
                            </Typography>
                        </BarrierCard>

                        <BarrierCard>
                            <BarrierNumber>05</BarrierNumber>
                            <BarrierTitle>HERKENNEN</BarrierTitle>
                            <Typography>
                                Herkennen professionals wanneer NOLIA voor een
                                ouder of gezin van betekenis kan zijn? En
                                herkent een ouder zichzelf in het aanbod?
                            </Typography>
                        </BarrierCard>

                        <BarrierCard>
                            <BarrierNumber>06</BarrierNumber>
                            <BarrierTitle>TOELEIDEN</BarrierTitle>
                            <Typography>
                                Is er een eenvoudige route waarmee een ouder niet
                                alleen wordt geïnformeerd, maar ook daadwerkelijk
                                bij een lokale NOLIA-bijeenkomst terechtkomt?
                            </Typography>
                        </BarrierCard>

                    </BarrierGrid>

                </SectionInner>
            </Section>


            {/* BREDE KIJK */}

            <Section background='light'>
                <SectionInner>

                    <IntroText>
                        <Typography>
                            Het NOLIA Toegankelijkheidsfonds richt zich daarom
                            niet alleen op het wegnemen van de financiële
                            drempel. We willen samen ontdekken wat er lokaal
                            nodig is om ook de andere drempels zo klein mogelijk
                            te maken.
                        </Typography>
                    </IntroText>

                </SectionInner>
            </Section>


            {/* WAT IS HET FONDS */}

            <FundSection>
                <SectionInner>

                    <Typography type='h2'>
                        Wat is het NOLIA Toegankelijkheidsfonds?
                    </Typography>

                    <IntroText>
                        <Typography>
                            <br />Het NOLIA Toegankelijkheidsfonds maakt het mogelijk
                            om binnen een gemeente of regio een aantal
                            deelnameplekken beschikbaar te stellen voor ouders
                            voor wie deelname anders minder vanzelfsprekend zou
                            zijn.
                        </Typography>

                        <Typography>
                            Een ouder of koppel dat via zo'n fondsplek deelneemt,
                            volgt het <strong>reguliere NOLIA
                            BabyFeeding-programma</strong>, zonder daarvoor zelf
                            een financiële bijdrage te betalen.
                        </Typography>
                    </IntroText>

                    <Highlight>

                        <Typography type='h3'>
                            Maar daar stopt het niet.
                        </Typography>

                        <Typography>
                            Samen met lokale professionals kijken we hoe ouders
                            worden bereikt, herkend en toegeleid. We brengen in
                            kaart wat goed werkt én waar drempels blijven
                            bestaan.
                        </Typography>

                        <Typography>
                            Zo is het Toegankelijkheidsfonds niet alleen een
                            manier om deelname mogelijk te maken, maar ook een
                            praktische manier om lokaal te{' '}
                            <strong>starten, leren en verbeteren.</strong>
                        </Typography>

                    </Highlight>

                </SectionInner>
            </FundSection>


            {/* WAT IS NOLIA */}

            <NoliaSection>
                <SectionInner>

                    <Typography type='h2'>
                        Even terug: wat is NOLIA BabyFeeding?
                    </Typography>

                    <IntroText>

                        <Typography>
                            <br />NOLIA BabyFeeding biedt preventieve babyvoedingszorg
                            rondom de geboorte.
                        </Typography>

                        <Typography>
                            Ouders bereiden zich tijdens de zwangerschap voor op
                            het voeden van hun baby en komen na de geboorte
                            opnieuw samen. In totaal bestaat NOLIA uit drie
                            bijeenkomsten: twee tijdens de zwangerschap en één na
                            de geboorte.
                        </Typography>

                        <Typography>
                            Daarbij kijken we bewust breder dan alleen naar
                            borstvoeding.
                        </Typography>

                    </IntroText>

                    <NoliaGrid>

                        <NoliaCard>
                            <Typography type='h3'>
                                Borst én fles
                            </Typography>
                            <Typography>
                                Ouders krijgen betrouwbare, neutrale informatie
                                over het voeden van hun baby.
                            </Typography>
                        </NoliaCard>

                        <NoliaCard>
                            <Typography type='h3'>
                                Babygedrag begrijpen
                            </Typography>
                            <Typography>
                                Wat vertelt een baby eigenlijk? En hoe kun je
                                voedingssignalen en ander gedrag leren herkennen?
                            </Typography>
                        </NoliaCard>

                        <NoliaCard>
                            <Typography type='h3'>
                                Samen voorbereiden
                            </Typography>
                            <Typography>
                                De partner of voedingsbuddy wordt actief
                                betrokken. Babyvoeding doe je niet alleen.
                            </Typography>
                        </NoliaCard>

                        <NoliaCard>
                            <Typography type='h3'>
                                Een sterker netwerk
                            </Typography>
                            <Typography>
                                Ouders ontmoeten andere ouders uit hun omgeving
                                en bouwen al tijdens de zwangerschap aan een
                                lokaal netwerk.
                            </Typography>
                        </NoliaCard>

                    </NoliaGrid>

                    <IntroText>

                        <Typography>
                            De bijeenkomsten worden gegeven door getrainde
                            NOLIA-begeleiders.
                        </Typography>

                        <Typography>
                            Het uitgangspunt is eenvoudig: niet pas ondersteuning
                            bieden wanneer er problemen zijn, maar ouders al vóór
                            de geboorte kennis, praktische vaardigheden en
                            vertrouwen meegeven.
                        </Typography>

                    </IntroText>

                </SectionInner>
            </NoliaSection>


            {/* HOE WERKT HET */}

            <RouteSection>
                <SectionInner>

                    <Typography type='h2'>
                        Hoe werkt het Toegankelijkheidsfonds?
                    </Typography>

                    <IntroText>
                        <Typography>
                            <br />De precieze aanpak kan per gemeente of regio
                            verschillen. Juist daarom starten we graag lokaal en
                            kijken we samen wat past.
                        </Typography>

                        <Typography>
                            <br />Een mogelijke route ziet er bijvoorbeeld zo uit:
                        </Typography>
                    </IntroText>

                    <Route>

                        <RouteItem>
                            <RouteNumber>1</RouteNumber>
                            <RouteContent>
                                <Typography type='h3'>
                                    Signaleren
                                </Typography>
                                <Typography>
                                    Een verloskundige, kraamzorgprofessional,
                                    JGZ-professional, lactatiekundige of andere
                                    betrokken professional herkent dat deelname
                                    aan NOLIA passend kan zijn en dat er drempels
                                    zijn waardoor deelname niet vanzelfsprekend is.
                                </Typography>
                            </RouteContent>
                        </RouteItem>

                        <RouteItem>
                            <RouteNumber>2</RouteNumber>
                            <RouteContent>
                                <Typography type='h3'>
                                    Bespreken
                                </Typography>
                                <Typography>
                                    De professional bespreekt de mogelijkheid met
                                    de ouder. Niet vanuit een label of oordeel,
                                    maar als één van de mogelijkheden voor extra
                                    voorbereiding en ondersteuning.
                                </Typography>
                            </RouteContent>
                        </RouteItem>

                        <RouteItem>
                            <RouteNumber>3</RouteNumber>
                            <RouteContent>
                                <Typography type='h3'>
                                    Verwijzen
                                </Typography>
                                <Typography>
                                    Wil de ouder deelnemen? Dan wordt de
                                    verbinding gelegd met het lokale NOLIA-aanbod.
                                </Typography>
                            </RouteContent>
                        </RouteItem>

                        <RouteItem>
                            <RouteNumber>4</RouteNumber>
                            <RouteContent>
                                <Typography type='h3'>
                                    Koppelen
                                </Typography>
                                <Typography>
                                    De ouder wordt gekoppeld aan een beschikbare
                                    bijeenkomst bij een NOLIA-begeleider in de
                                    omgeving.
                                </Typography>
                            </RouteContent>
                        </RouteItem>

                        <RouteItem>
                            <RouteNumber>5</RouteNumber>
                            <RouteContent>
                                <Typography type='h3'>
                                    Deelnemen
                                </Typography>
                                <Typography>
                                    Via een fondsplek kan de ouder of het koppel
                                    zonder financiële bijdrage deelnemen aan het
                                    reguliere NOLIA-programma.
                                </Typography>
                            </RouteContent>
                        </RouteItem>

                        <RouteItem>
                            <RouteNumber>6</RouteNumber>
                            <RouteContent>
                                <Typography type='h3'>
                                    Leren en evalueren
                                </Typography>
                                <Typography>
                                    We kijken samen wat er gebeurt. Worden de
                                    beschikbare plekken gevonden? Welke routes
                                    werken goed? Waar lopen ouders of professionals
                                    tegenaan? En wat kunnen we verbeteren?
                                </Typography>
                            </RouteContent>
                        </RouteItem>

                    </Route>

                </SectionInner>
            </RouteSection>


            {/* SAMENWERKING */}

            <CollaborationSection>
                <SectionInner>

                    <Typography type='h2'>
                        We doen dit samen
                    </Typography>

                    <IntroText>
                        <Typography>
                            <br />Toegankelijkheid kun je niet vanuit één organisatie
                            regelen. Daarom is lokale samenwerking een belangrijk
                            onderdeel van het Toegankelijkheidsfonds.
                        </Typography>
                    </IntroText>

                    <CollaborationGrid>

                        <CollaborationCard>
                            <Typography type='h3'>
                                NOLIA BabyFeeding
                            </Typography>
                            <Typography>
                                NOLIA stelt binnen een lokale pilot materialen
                                voor afgesproken fondsplekken beschikbaar en
                                ondersteunt bij het ontwikkelen en evalueren van
                                de lokale aanpak.
                            </Typography>
                        </CollaborationCard>

                        <CollaborationCard>
                            <Typography type='h3'>
                                De NOLIA-begeleider
                            </Typography>
                            <Typography>
                                Een lokale NOLIA-begeleider maakt binnen de eigen
                                groepen afgesproken deelnameplekken beschikbaar
                                en begeleidt ouders tijdens het reguliere
                                programma.
                            </Typography>
                        </CollaborationCard>

                        <CollaborationCard>
                            <Typography type='h3'>
                                Lokale zorg- en welzijnsprofessionals
                            </Typography>
                            <Typography>
                                Professionals rondom zwangerschap, geboorte en
                                het jonge gezin kunnen een belangrijke rol spelen
                                in het herkennen, informeren en toeleiden van
                                ouders.
                            </Typography>
                            <Typography>
                                Wie dat precies zijn, verschilt per regio. Denk
                                bijvoorbeeld aan verloskunde, kraamzorg, JGZ,
                                lactatiekundige zorg en professionals binnen het
                                sociaal domein.
                            </Typography>
                        </CollaborationCard>

                        <CollaborationCard>
                            <Typography type='h3'>
                                Gemeente, regio of Kansrijke Start-coalitie
                            </Typography>
                            <Typography>
                                Een gemeente of lokaal samenwerkingsverband kan
                                partijen bij elkaar brengen en samen met NOLIA
                                onderzoeken wat er nodig is om preventieve
                                babyvoedingszorg lokaal toegankelijk te maken.
                            </Typography>
                        </CollaborationCard>

                        <CollaborationCard>
                            <Typography type='h3'>
                                Ouders
                            </Typography>
                            <Typography>
                                En uiteindelijk draait het natuurlijk om hen.
                                Ouders moeten niet alleen een beschikbare plek
                                hébben, maar zich ook welkom voelen en daadwerkelijk
                                gebruik kunnen maken van het aanbod.
                            </Typography>
                        </CollaborationCard>

                    </CollaborationGrid>

                </SectionInner>
            </CollaborationSection>


            {/* VAN PLEK NAAR ROUTE */}

            <Section>
                <SectionInner>

                    <Typography type='h2'>
                        Van beschikbare plekken naar een werkende lokale route
                    </Typography>

                    <IntroText>

                        <Typography>
                            <br />Dit is misschien wel het belangrijkste onderdeel van
                            het Toegankelijkheidsfonds.
                        </Typography>

                        <Typography>
                            Stel dat er tien gratis plekken beschikbaar zijn,
                            maar geen enkele ouder weet ervan. Dan hebben we
                            financieel iets opgelost, maar is het aanbod nog
                            steeds niet toegankelijk.
                        </Typography>

                        <Typography>
                            <br />Daarom willen we tijdens een lokale pilot niet alleen
                            kijken naar hoeveel ouders deelnemen. We willen
                            begrijpen <strong>hoe zij daar terechtkomen.</strong>
                        </Typography>

                    </IntroText>

                    <LearningSection>

                        <Typography type='h3'>
                            Bijvoorbeeld:
                        </Typography>

                        <LearningList>
                            <li>Hoe horen ouders over NOLIA?</li>
                            <li>Welke professionals herkennen en bespreken de mogelijkheid?</li>
                            <li>Via welke routes worden ouders toegeleid?</li>
                            <li>Welke drempels komen we onderweg tegen?</li>
                            <li>Worden beschikbare plekken daadwerkelijk gebruikt?</li>
                            <li>Waar haken ouders eventueel af?</li>
                            <li>Wat helpt juist om de stap naar deelname gemakkelijker te maken?</li>
                        </LearningList>

                    </LearningSection>

                    <IntroText>

                        <Typography>
                            <br />Zo ontstaat niet alleen ondersteuning voor de ouders
                            die nu deelnemen, maar ook kennis waarmee we de route
                            voor toekomstige ouders kunnen verbeteren.
                        </Typography>

                    </IntroText>

                </SectionInner>
            </Section>


            {/* STARTEN LEREN VERBETEREN */}

            <StartSection>
                <SectionInner>

                    <Typography type='h2'>
                        Starten, leren, verbeteren
                    </Typography>

                    <IntroText>
                        <Typography>
                            <br />We hoeven niet te wachten tot ieder vraagstuk rondom
                            structurele financiering en lokale organisatie
                            volledig is opgelost.
                        </Typography>

                        <Typography>
                            <br />Het Toegankelijkheidsfonds biedt juist de mogelijkheid
                            om <strong>klein en concreet te beginnen.</strong>
                        </Typography>
                    </IntroText>

                    <StartFlow>

                        <StartItem>
                            <strong>Starten</strong>
                        </StartItem>

                        <StartItem>
                            <strong>Leren</strong>
                        </StartItem>

                        <StartItem>
                            <strong>Verbeteren</strong>
                        </StartItem>

                        <StartItem>
                            <strong>Structurele mogelijkheden verkennen</strong>
                        </StartItem>

                    </StartFlow>

                    <IntroText>

                        <Typography>
                            We spreken lokaal af hoeveel fondsplekken beschikbaar
                            worden gemaakt en hoe ouders kunnen worden bereikt en
                            toegeleid. Vervolgens volgen en evalueren we wat er
                            gebeurt.
                        </Typography>

                        <Typography>
                            Die ervaringen kunnen helpen om samen beter te
                            begrijpen wat er nodig is om preventieve
                            babyvoedingszorg ook op langere termijn toegankelijk
                            te maken.
                        </Typography>

                        <Typography>
                            Het Toegankelijkheidsfonds is daarmee niet per
                            definitie het uiteindelijke financieringsmodel. Het
                            kan juist een eerste praktische stap zijn richting een
                            aanpak die uiteindelijk lokaal geborgd kan worden.
                        </Typography>

                    </IntroText>

                </SectionInner>
            </StartSection>


            {/* VOOR WIE */}

            <Section>
                <SectionInner>

                    <Typography type='h2'>
                        Voor wie is het Toegankelijkheidsfonds bedoeld?
                    </Typography>

                    <IntroText>

                        <Typography>
                            <br />Het fonds is bedoeld om deelname mogelijk te maken
                            voor ouders voor wie preventieve babyvoedingszorg
                            door financiële of andere toegankelijkheidsdrempels
                            minder vanzelfsprekend bereikbaar is.
                        </Typography>

                        <Typography>
                            We werken bewust niet vanuit één landelijk label voor
                            wie daar wel of niet onder valt.
                        </Typography>

                        <Typography>
                            De omstandigheden, bestaande voorzieningen en lokale
                            behoeften verschillen immers per gemeente en regio.
                        </Typography>

                        <Typography>
                            Daarom maken we binnen een lokale pilot afspraken over
                            de doelgroep, beschikbare plekken en manier van
                            herkennen en toeleiden.
                        </Typography>

                    </IntroText>

                </SectionInner>
            </Section>


            {/* WAAROM LOKAAL */}

            <Section background='light'>
                <SectionInner>

                    <Typography type='h2'>
                        Waarom lokaal?
                    </Typography>

                    <IntroText>

                        <Typography>
                            <br />Een toegankelijkheidsvraagstuk in Rotterdam kan er
                            anders uitzien dan in een dorp in Limburg of Gelderland.
                        </Typography>

                        <Typography>
                            Welke ondersteuning bestaat al? Waar vinden ouders
                            informatie? Welke professionals kennen gezinnen goed?
                            Waar worden zwangeren gezien? Welke NOLIA-begeleiders
                            zijn actief? En welke drempels ervaren ouders zelf?
                        </Typography>

                        <Typography>
                            Daarom geloven we niet in één route die we simpelweg
                            over iedere gemeente heen kunnen leggen.
                        </Typography>

                        <Typography>
                            NOLIA brengt het concept, de babyvoedingszorg,
                            materialen en ervaringen mee. Lokale professionals
                            kennen hun omgeving en de ouders die er wonen.
                        </Typography>

                    </IntroText>

                    <Highlight>

                        <Typography>
                            <strong>
                                Juist die combinatie maakt het mogelijk om te
                                ontdekken wat lokaal werkt.
                            </strong>
                        </Typography>

                    </Highlight>

                </SectionInner>
            </Section>


            {/* KANSRIJKE START */}

            <Section>
                <SectionInner>

                    <Typography type='h2'>
                        Werken jullie binnen Kansrijke Start aan toegankelijkheid?
                    </Typography>

                    <IntroText>

                        <Typography>
                            <br />Dan denken we graag mee.
                        </Typography>

                        <Typography>
                            <br />Het NOLIA Toegankelijkheidsfonds kan worden verkend
                            binnen een gemeente, regio of lokaal
                            samenwerkingsverband dat wil onderzoeken hoe
                            preventieve babyvoedingszorg beter bereikbaar kan
                            worden voor ouders voor wie deelname nu minder
                            vanzelfsprekend is.
                        </Typography>

                        <Typography>
                            We beginnen daarbij niet met een vast pakket dat
                            overal hetzelfde moet worden uitgevoerd. We kijken
                            eerst samen:
                        </Typography>

                    </IntroText>

                    <LearningList>
                        <li>Wat gebeurt er lokaal al?</li>
                        <li>Welke ouders willen jullie beter bereiken?</li>
                        <li>Waar zitten op dit moment de belangrijkste drempels?</li>
                        <li>Welke professionals kunnen een rol spelen?</li>
                        <li>Is er lokaal NOLIA-aanbod beschikbaar?</li>
                        <li>Hoe zou een eerste pilot eruit kunnen zien?</li>
                        <li>En vooral: wat willen we daarvan leren?</li>
                    </LearningList>

                </SectionInner>
            </Section>


            {/* GEMEENTE CTA */}

            <CTAGroup>

                <Typography type='h2'>
                    Benieuwd wat het NOLIA Toegankelijkheidsfonds in jullie gemeente of regio kan betekenen?
                </Typography>

                <Typography>
                    We denken graag vrijblijvend mee over de mogelijkheden en een
                    passende eerste stap.
                </Typography>

                <Button
                    text='Plan een verkennend gesprek'
                    to='/gesprek'
                    buttonstyle='primary'
                    style={{ marginTop: '1em' }}
                />

            </CTAGroup>


            {/* PROFESSIONALS */}

            <ParentSection>

                <SectionInner>

                    <Typography type='h2'>
                        Werk je met (aanstaande) ouders?
                    </Typography>

                    <IntroText>

                        <Typography>
                            <br />Ook als zorg- of welzijnsprofessional kun je een
                            belangrijke rol spelen in toegankelijkheid.
                        </Typography>

                        <Typography>
                            Misschien herken je ouders voor wie extra
                            voorbereiding rondom babyvoeding waardevol kan zijn,
                            maar voor wie deelname aan bestaand aanbod niet
                            vanzelfsprekend is. Of misschien zie je in jouw regio
                            juist een drempel waarvan je denkt: <em>hier zouden we
                            iets mee moeten.</em>
                        </Typography>

                        <Typography>
                            We horen graag wat jij in de praktijk ziet.
                        </Typography>

                    </IntroText>

                    <Button
                        text='Neem contact met ons op'
                        to='/contact'
                        buttonstyle='secondary'
                        style={{ marginTop: '1em' }}
                    />

                </SectionInner>

            </ParentSection>


            {/* OUDERS */}

            <Section background='light'>
                <SectionInner>

                    <Typography type='h2'>
                        Ben je ouder en denk je: misschien is dit voor mij?
                    </Typography>

                    <IntroText>

                        <Typography>
                            <br />Fijn dat je hier terecht bent gekomen.
                        </Typography>

                        <Typography>
                            De mogelijkheden vanuit het NOLIA
                            Toegankelijkheidsfonds verschillen op dit moment per
                            gemeente en regio. Een fondsplek is daarom niet
                            automatisch overal beschikbaar.
                        </Typography>

                        <Typography>
                            Wil je weten of er bij jou in de omgeving mogelijkheden
                            zijn? Neem gerust contact met ons op. Dan kijken we
                            samen wat er lokaal beschikbaar is.
                        </Typography>

                    </IntroText>

                    <Button
                        text='Vraag naar de mogelijkheden'
                        to='/contact'
                        buttonstyle='primary'
                        style={{ marginTop: '1em' }}
                    />

                </SectionInner>
            </Section>


            {/* FAQ */}

            <FAQSection>
                <SectionInner>

                    <Typography type='h2'>
                        Veelgestelde vragen
                    </Typography>

                    <FAQItem>
                        <Typography type='h3'>
                            Wat is het NOLIA Toegankelijkheidsfonds?
                        </Typography>

                        <Typography>
                            Het NOLIA Toegankelijkheidsfonds is een initiatief
                            van NOLIA BabyFeeding waarmee we lokaal
                            deelnameplekken beschikbaar kunnen maken voor ouders
                            voor wie deelname minder vanzelfsprekend is.
                            Tegelijkertijd werken we met lokale partners aan het
                            herkennen, bereiken en toeleiden van ouders en leren
                            we wat er nodig is om preventieve babyvoedingszorg
                            beter toegankelijk te maken.
                        </Typography>
                    </FAQItem>

                    <FAQItem>
                        <Typography type='h3'>
                            Is het alleen bedoeld voor ouders die NOLIA niet kunnen betalen?
                        </Typography>

                        <Typography>
                            Nee. Financiën kunnen een belangrijke drempel zijn,
                            maar toegankelijkheid gaat over meer. Daarom kijken
                            we ook naar vindbaarheid, nabijheid, vertrouwen,
                            herkennen en toeleiden. Een gratis plek helpt immers
                            alleen wanneer een ouder het aanbod kent, zich erin
                            herkent en daadwerkelijk bij een bijeenkomst terecht
                            kan komen.
                        </Typography>
                    </FAQItem>

                    <FAQItem>
                        <Typography type='h3'>
                            Is deelname via een fondsplek gratis voor ouders?
                        </Typography>

                        <Typography>
                            Wanneer een ouder binnen een lokale pilot via een
                            fondsplek deelneemt, betaalt de ouder zelf geen
                            bijdrage voor deelname aan het reguliere
                            NOLIA-programma.
                        </Typography>
                    </FAQItem>

                    <FAQItem>
                        <Typography type='h3'>
                            Wie kan een ouder verwijzen?
                        </Typography>

                        <Typography>
                            Dat kan per lokale pilot verschillen. Samen met de
                            betrokken gemeente, regio en professionals spreken we
                            af hoe de route eruitziet en welke professionals
                            daarbij betrokken zijn.
                        </Typography>
                    </FAQItem>

                    <FAQItem>
                        <Typography type='h3'>
                            Is het Toegankelijkheidsfonds overal in Nederland beschikbaar?
                        </Typography>

                        <Typography>
                            Niet automatisch. De beschikbaarheid van fondsplekken
                            is afhankelijk van lokale pilots, beschikbare
                            NOLIA-begeleiders en gemaakte afspraken. Neem gerust
                            contact met ons op wanneer je wilt weten wat er in
                            jouw gemeente of regio mogelijk is.
                        </Typography>
                    </FAQItem>

                    <FAQItem>
                        <Typography type='h3'>
                            Wat doet NOLIA zelf?
                        </Typography>

                        <Typography>
                            NOLIA draagt binnen een lokale pilot materialen voor
                            afgesproken fondsplekken bij, ondersteunt bij de
                            lokale aanpak en helpt bij het verzamelen en
                            evalueren van ervaringen. De precieze afspraken kunnen
                            per pilot verschillen.
                        </Typography>
                    </FAQItem>

                    <FAQItem>
                        <Typography type='h3'>
                            Wat wordt er van een gemeente of regio verwacht?
                        </Typography>

                        <Typography>
                            Dat bepalen we samen. Een gemeente of regio kan
                            bijvoorbeeld helpen om lokale partners bij elkaar te
                            brengen, mee te denken over bereik en toeleiding en te
                            onderzoeken hoe preventieve babyvoedingszorg lokaal
                            toegankelijk kan worden gemaakt.
                        </Typography>

                        <Typography>
                            We starten daarom bij voorkeur met een verkennend
                            gesprek over de bestaande situatie en lokale behoefte.
                        </Typography>
                    </FAQItem>

                    <FAQItem>
                        <Typography type='h3'>
                            Is het Toegankelijkheidsfonds een structurele financieringsregeling?
                        </Typography>

                        <Typography>
                            Nee. Het fonds kan juist worden ingezet om lokaal te
                            starten, ervaring op te doen en te onderzoeken wat
                            nodig is voor duurzame toegankelijkheid. De inzichten
                            uit een pilot kunnen vervolgens worden gebruikt om
                            samen structurele mogelijkheden voor borging en
                            financiering te verkennen.
                        </Typography>
                    </FAQItem>

                    <FAQItem>
                        <Typography type='h3'>
                            Kunnen we het Toegankelijkheidsfonds ook in onze gemeente of regio inzetten?
                        </Typography>

                        <Typography>
                            Dat onderzoeken we graag samen. We kijken onder andere
                            naar het bestaande lokale aanbod, beschikbare
                            NOLIA-begeleiders, de doelgroep die jullie willen
                            bereiken, mogelijke verwijzers en de vraag wat jullie
                            met een pilot willen leren.
                        </Typography>

                        <Button
                            text='Plan een verkennend gesprek'
                            to='/gesprek'
                            buttonstyle='primary'
                            style={{ marginTop: '0.75em' }}
                        />
                    </FAQItem>

                </SectionInner>
            </FAQSection>


            {/* AFSLUITING */}

            <ClosingSection>

                <ClosingContent>

                    <Typography type='h2'>
                        Zorgen dat een beschikbare plek ook een bereikbare plek wordt
                    </Typography>

                    <Typography>
                        <br />Preventieve ondersteuning kan pas verschil maken als
                        ouders er daadwerkelijk bij kunnen komen.
                    </Typography>

                    <Typography>
                        Daarom willen we met het NOLIA Toegankelijkheidsfonds niet
                        alleen financiële ruimte creëren. We willen samen met
                        lokale professionals, gemeenten en regio's ontdekken wat
                        er nodig is om ouders te <strong>vinden, bereiken,
                        herkennen én toe te leiden.</strong>
                    </Typography>

                    <Typography type='h3'>
                        <br />Klein beginnen. Samen leren. Verbeteren wat nodig is.
                        En vanuit daar verder bouwen aan preventieve
                        babyvoedingszorg die voor steeds meer ouders daadwerkelijk
                        toegankelijk is.
                    </Typography>

                    <Button
                        text='Plan een verkennend gesprek'
                        to='/gesprek'
                        buttonstyle='primary'
                        style={{ marginTop: '1em' }}
                    />

                </ClosingContent>

            </ClosingSection>

        </Container>
    );
}